module.exports = __webpack_public_path__ + "img/7.f1be45d.png";